 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		48: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		48: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"1":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","4":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","5":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","6":"AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","8":"Checkout~Gift","9":"LandingPage~Pricing","10":"RegistrationModal~SwitchAccountModal","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"FeaturedArtwork","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"MemberHomepage","29":"MyCollections","30":"MyStudents","31":"Onboarding","32":"PracticeSkill","33":"PredefinedCollectionsDetail","34":"Pricing","35":"ProgressTracker","36":"RegistrationModal","37":"RelatedGuidedLesson","38":"Reviews","39":"SeasonalDaysDropdown","40":"Sellpage","41":"SubPlansList","42":"SwitchAccountModal","43":"TakeAssessmentModal","44":"vendors~Gift","45":"vendors~MemberHomepage","46":"vendors~MyStudents","47":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"0e28bcdf7e4e2d955c5f","1":"760f0f2e456019a49865","2":"ff6d8f4757c4cbe82490","3":"688fcb0e4233ddee01c8","4":"c587cac2c3dcb0d48070","5":"8f75136ad1cf9bee2874","6":"df33acaa603a95fcd393","7":"727384f0c5e0fae6e2ca","8":"4dd32bb339fa0111883a","9":"f1fb590d3c415a7e2174","10":"d903f7125c1d2a2397b8","11":"ade6c7414be96b36c579","12":"01dcb35192474be049a1","13":"023949957394aa2f4eb8","14":"f84b7c4f4ec78169e35f","15":"d044dc8e717291e2ea46","16":"19f0f3d642f739000918","17":"c4e68d299be2ac4d8629","18":"933c512a8d24115f0b7f","19":"3d88d2ec5220eacd418e","20":"85000f46716918e0c9df","21":"8cd2716933548535c628","22":"c6f2c79fc3115d2efd81","23":"cd1953011d7827c592b6","24":"21d112546436b762a76c","25":"1ba44d03898594951c82","26":"3e0455afc98258616ddc","27":"3a697af64cc8ac20b010","28":"9da32c130a80a448dfd6","29":"cf66d4ace84a09ef9df3","30":"58c217162fb8ef2306a1","31":"56c232d81ec3fbd9fd7d","32":"7b6ad788e7dd81fcd97e","33":"62662db49028b35ed95d","34":"6fbaecfc36c047bb1911","35":"4207101cb36d2a83a3ac","36":"cd21a8fe2b841f76a5a3","37":"9f034c1156180139e0f0","38":"afc7fc83ae59a71e8270","39":"248ee5cd0b492090a125","40":"d2b7f9712f70d6dab8e1","41":"290e2b83ca18fb2fe7c1","42":"5f1ca92359c4fce0a63c","43":"f2bab5d926485b26a6ab","44":"c84bcead4021222cbcdf","45":"5a6dc63e04141040a2c0","46":"1609a2d35296bd714c70","47":"00eadf8c6ffac049c430","50":"4c83b63d20221f31bd85","51":"7e1d08e46a8611053f35"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1,"8":1,"9":1,"10":1,"12":1,"13":1,"14":1,"15":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"28":1,"29":1,"30":1,"31":1,"32":1,"34":1,"35":1,"38":1,"39":1,"40":1,"43":1,"44":1,"50":1,"51":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"1":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","4":"vendors~Assessments~GoalDetails~MemberHomepage~ProgressTracker","5":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","6":"AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","8":"Checkout~Gift","9":"LandingPage~Pricing","10":"RegistrationModal~SwitchAccountModal","12":"AccountSettings","13":"Assessments","14":"AssignmentsModalV2","15":"AssignmentsV2","16":"BackToSchoolBundle","17":"BrainzyPaint","18":"Checkout","19":"FeaturedArtwork","20":"Gift","21":"GoalDetails","22":"GradeFilteredContentCards","23":"GradeWorksheetModal","24":"HomeLearning","25":"KidFrame","26":"KidFrameDetail","27":"LandingPage","28":"MemberHomepage","29":"MyCollections","30":"MyStudents","31":"Onboarding","32":"PracticeSkill","33":"PredefinedCollectionsDetail","34":"Pricing","35":"ProgressTracker","36":"RegistrationModal","37":"RelatedGuidedLesson","38":"Reviews","39":"SeasonalDaysDropdown","40":"Sellpage","41":"SubPlansList","42":"SwitchAccountModal","43":"TakeAssessmentModal","44":"vendors~Gift","45":"vendors~MemberHomepage","46":"vendors~MyStudents","47":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"21c26712ad69a7171d89","7":"31d6cfe0d16ae931b73c","8":"dff7ff826b2c488d7287","9":"2b436e69b3b155a4a770","10":"45ea3a3893042d5019ec","11":"31d6cfe0d16ae931b73c","12":"4ad35bb3dca41c2cae0b","13":"1281073053201baa5292","14":"13a4e7436120b3088257","15":"681ffe45eaa49fb7d947","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"2087248043751533f11c","19":"d56d9288e4c0c7368f48","20":"1b02f180c676ddd743cd","21":"70874abc2be77d282a23","22":"0ccdbb0bed9d9a533985","23":"78f108ef2a1e16d4d1b4","24":"4c89bea8f7f35505c32a","25":"fa5453dc24744b78df9b","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"8063bf354b418fa1823e","29":"ab19f0324e469dc86f86","30":"f88d04acd98bbf90b54c","31":"3e3946facd93a178be00","32":"5491656ee574e8b4a49d","33":"31d6cfe0d16ae931b73c","34":"cc6b5ccd34bf09b0f268","35":"824c284a8359b1c24485","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"3eb70bdfce6885905434","39":"495c0b9853cb793a31ee","40":"b2241e69244058888926","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"bf40f2159a5c06b0446f","44":"ca68f8fa1dd9edae64fc","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","50":"c7c112df630d782cdeed","51":"c7c112df630d782cdeed"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([394,49]);
 	// run deferred modules when ready
 	return checkDeferredModules();
